import { render } from "./BezierPaths.vue?vue&type=template&id=7c6a2f10&scoped=true"
import script from "./BezierPaths.vue?vue&type=script&lang=js"
export * from "./BezierPaths.vue?vue&type=script&lang=js"

import "./BezierPaths.vue?vue&type=style&index=0&id=7c6a2f10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6a2f10"]])

export default __exports__